"use client";

import { useState } from "react";
import { BookletDate } from "@/@types";
import Link from "next/link";
import { ROUTES } from "@/config/routes";

type Props = {
  bookletsDate: BookletDate;
};

export default function BookletsDateCard({ bookletsDate }: Props) {
  const [openMonths, setOpenMonths] = useState<{ [key: string]: boolean }>({});
  const toggleMonth = (month: string) => {
    setOpenMonths((prev) => ({
      ...prev,
      [month]: !prev[month],
    }));
  };

  return (
    <div>
      {Object.entries(bookletsDate).map(([monthYear, booklets]) => {
        const isOpen = openMonths[monthYear];
        return (
          <div key={monthYear} className="mb-1">
            <div className="bg-white">
              <button
                onClick={() => toggleMonth(monthYear)}
                className="w-full flex items-center justify-between border-grey border-b-2 p-2 text-gray-700 hover:bg-gray-100 focus:outline-none"
              >
                <span>{monthYear}</span>
              </button>
              {isOpen && (
                <div className="pl-6 bg-gray-100">
                  {booklets.map((booklet, index) => (
                    <Link
                      key={index}
                      href={ROUTES.literature.details(
                        booklet.category_slug,
                        booklet.slug
                      )}
                      className="block py-2 text-sm text-gray-600 hover:text-gray-800"
                    >
                      {booklet.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
